import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GlobalComponentsModule} from '../../../global-components/global-components.module';
import {SharedComponentsModule} from '../shared-components/shared-components.module';
import {GiftCardShopHomeControllerComponent} from './gift-card-shop-home-controller.component';
import {RouterModule} from '@angular/router';

@NgModule({
    declarations: [
        GiftCardShopHomeControllerComponent
    ],
    exports: [
        GiftCardShopHomeControllerComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        GlobalComponentsModule,
        SharedComponentsModule,
    ]
})
export class GiftCardShopHomeModule {}
